
/*
* @Author: syyoon@yongtrim.com 
* @Date: 2018-08-06 20:07:10 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-08-14 23:36:34
*/
import _ from 'lodash';

import { Donator } from "./donator.model";

export interface Celeb {
  _id: string;

  user: string;
  
  group: Celeb;

  isGroup: boolean;

  categories: [string];

  name: string;
  title: string;
  description: string;

  thumbnailId: string;
  photoIds: [string];

  averageWatingDays: number;
  price: number;

  claps: [{ user: string, count: Number }];
  countClaps: number;
  countComments: number;

  donators: [Donator];
  
  bookmarks: any;
  
  members: [Celeb];

  isNewbie: boolean;
  newbieDueAt: Date;

  groupName: string;

  requestCount: number;

  wantedPrice: number;
  wantedCount: number;

  accountName: string;
  accountNumber: string;
  bankName: string;

  basicRate: number;
  commissionRate: number;

  agreeToCommission: boolean;
  // 
  // locals
  myCountClaps: number;
  isBookmark: boolean;
}


export function celebGenLocals(celeb, userId) {
  if (!celeb)
    return;
  celeb.myCountClaps = 0;
  _.forEach(celeb.claps, clap => {
    if (clap.user === userId) {
      celeb.myCountClaps += clap.count;
    }
  });

  if (userId && celeb.bookmarks) {
    celeb.isBookmark = _.includes(celeb.bookmarks, userId);
  } else {
    celeb.isBookmark = false;
  }
}




// WEBPACK FOOTER //
// ./src/models/celeb.model.ts